// Role -> route prefix mapping ek hi jagah.
// App me sirf do route trees hain: /admin aur /doctor.
// PROVIDER ko DOCTOR wale tree me rakha gaya hai (Sidebar bhi yahi karta hai).
const ROLE_BASE_PATH = {
  ADMIN: "/admin",
  DOCTOR: "/doctor",
  PROVIDER: "/doctor",
};

export const getRoleBasePath = (role) =>
  ROLE_BASE_PATH[String(role || "").toUpperCase()] || null;

export const getRoleHomePath = (role) => {
  const basePath = getRoleBasePath(role);
  if (!basePath) {
    console.error(
      "[auth] Unknown role from login response:",
      JSON.stringify(role),
      "-- expected one of",
      Object.keys(ROLE_BASE_PATH)
    );
    return null;
  }
  return `${basePath}/dashboard`;
};

export const normalizeRoutePath = (path) =>
  String(path || "").replace(/^\/+|\/+$/g, "");

export default ROLE_BASE_PATH;
